import React, { Component } from 'react';
import { connect } from 'react-redux';
import PaymentsView from './Payments.view';

import { getPayments } from './Payments.selectors';

export class PaymentsContainer extends Component {

  constructor(props){
    super(props);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.exportCSV = this.exportCSV.bind(this);
    this.openCreateModal = this.openCreateModal.bind(this);
    this.openCrossCheckModal = this.openCrossCheckModal.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'FETCH_OFFERS_FOR_PAYMENTS',
      payload: {},
    });

    this.getPayments(this.props);
    this.intervalId = setInterval(()=>{
      this.getPayments(this.props);
    }, 30000);
  }

  componentWillReceiveProps(nextProps){
    if(
      this.props.filtersFormState !== nextProps.filtersFormState ||
      this.props.page !== nextProps.page
    ){
      this.getPayments(nextProps);
    }
  }

  getPayments(props){
    const { dispatch, filtersFormState, page } = props;
    dispatch({
      type: 'FETCH_PAYMENTS',
      payload: {
        filters: filtersFormState.data,
        page: page,
      }
    });
  }

  componentWillUnmount(){
    clearInterval(this.intervalId);
  }

  nextPage(){
    const { dispatch } = this.props;
    dispatch({
      type: 'PAYMENTS_NEXT_PAGE',
    });
  }

  previousPage(){
    const { dispatch } = this.props;
    dispatch({
      type: 'PAYMENTS_PREVIOUS_PAGE',
    });
  }

  onFilterChange(filtersFormState){
    const { dispatch } = this.props;
    dispatch({
      type: 'PAYMENT_FILTERS_CHANGE',
      payload: {
        filtersFormState,
      }
    });
  }

  openCreateModal() {
    const { dispatch } = this.props;
    dispatch({
      type: 'TOGGLE_MODAL',
      payload: {
        active: true,
      }
    });
  }

  openCrossCheckModal() {
    const { dispatch } = this.props;
    dispatch({
      type: 'TOGGLE_CROSS_CHECK_MODAL',
      payload: {
        active: true,
      }
    });
  }

  exportCSV(exportType = 'Raise.com'){
    const { dispatch, filtersFormState } = this.props;
    dispatch({
      type: 'EXPORT_PAYMENTS_CSV',
      payload: {
        exportType,
        filters: filtersFormState.data,
      }
    });
  }

  render() {
    return (<PaymentsView
      onFilterChange={this.onFilterChange}
      nextPage={this.nextPage}
      previousPage={this.previousPage}
      exportCSV={this.exportCSV}
      openCreateModal={this.openCreateModal}
      openCrossCheckModal={this.openCrossCheckModal}
      {...this.props}
    />);
  }

}

function mapStateToProps(state) {
  const { payments, dynamicData } = state;
  return {
    payments: getPayments(state),
    filtersFormState: payments.filtersFormState,
    page: payments.page,
  };
}

export default connect(mapStateToProps)(PaymentsContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Payments/Payments.container.js